export default {
  "badge-highlight": "_badge-highlight_njqp7a",
  "primary": "_primary_njqp7a",
  "secondary": "_secondary_njqp7a"
};